export default class {
  constructor(messagingApiService) {
    this.messagingApiService = messagingApiService
  }

  purchase(purchaseInformation) {
    return this.messagingApiService.post(`/pins/${purchaseInformation.sentenceNumber}/${purchaseInformation.numberOfTexts}`)
  }
}